import Immutable from 'seamless-immutable';
// --- external imports ------

import * as types from './actionTypes';
// --- local imports ------

const initialState = Immutable({
	all: [],
	hiredBooths: [],
	tradeshowCustomers: [],
});

export default function reduce(state = initialState, action) {
	switch (action.type) {

	case types.TRADESHOW_FETCHED_ALL:
		return state.merge({ all: action.allTradeshows });

	case types.TRADESHOW_FETCHED_HIRED:
		return state.merge({ hiredBooths: action.hiredTradeshowBooths });

	case types.TRADESHOW_HIRE:
		return state.merge({ hiredBooths: [...state.hiredBooths, action.hiredTradeshowBooth] });
	
	case types.TRADESHOW_STARTED:
		return state.merge({ tradeshowCustomers: [...action.tradeshowCustomers] });
		
	case types.TRADESHOW_ENDED:
		return state.merge({ tradeshowCustomers: [] });

	default:
		return state;
	}
}
